<template lang="pug">
.common-form-table.w-full
  slot(name="table_options")
  slot(name="table_custom_top_scroll")
  div.table-container.overflow-auto.rounded
    f-editable-table.items-table(
      ref="commonFrmTbl"
      :domId="'table-container-' + domId"
      :style="width? `min-width: ${width}` : ''"
      :column-sizes='columnSizes'
      :columns="columns"
      :rows="rows"
      :context-actions="actions"
      :showFooter="showFooter"
      :is-show-context="isShowContext"
      :is-allow-sorting='isAllowSorting'
      :is-header-sorting-enabled="isHeaderSortingEnabled"
      :showSummary="showSummary"
      :is-move-right-on-enter="isMoveRightOnEnter"
      :vertical-enter-stop-column="verticalEnterStopColumn"
      :isFixedHeader="isFixedHeader"
      :isFixedHeaderSaleScreen="isFixedHeaderSaleScreen"
      :reset-sort="resetSort"
      @on-searching-select-box="$emit('on-searching-select-box', $event), currentSearchInput = $event.searchInput"
      @input='onInput($event)'
      @checkbox-change='$emit("checkbox-change", $event)'
      @on-select="$emit('on-select', $event)"
      @even-right-click="eventInRightClick"
      @reorder="onReorder"
      @bodyclick="onBodyClick"
      @outsideclick="outsideclick"
      @cell-enter="(event)=>onEnterCell(event)"
      @blur="(event)=>onBlurCell(event)"
      @cursor="updateCursor"
      @update:columnSizes="changeColumnSizes"
      :disabled="disabled"
      :auto-focus-first-cell="autoFocusFirstCell"
      :keepRowHighlight="keepRowHighlight"
      :isFocusSecondCell="isFocusSecondCell"
      :count-entire-total="countEntireTotal"
      :is-show-index-column="isShowIndexColumn"
      @on-load-more="onLoadMore"
      @sort-change="$emit('sort-change', $event)"
    )
      template(v-slot:header='{column}')
        slot(:name="'header-' + column.name")
          span(v-if="column.customHeaderName") {{column.customHeaderName}}
          span(v-else) {{$t(`table_common.${column.name}`)}}
          span.red--text {{column.required ? '*' : ''}}
      template(v-slot:cell-mix_details="{row}")
        v-btn(small icon color="primary" @click.stop="$emit('updateMix', row)")
          v-icon mdi-playlist-edit
      template(v-slot:cell-order_input="{row}")
        v-btn(small icon color="primary" @click.stop="$emit('inputOrder', row)" :disabled="disabledInputOrder(row)")
          v-icon mdi-playlist-edit
      template(v-slot:total)
        slot(name="total")
      template(v-slot:cell-input-dropdown-item-item='{dropdownItem}')
        v-row.px-0.mx-0.dropdown-item
          v-col.px-0.mx-0(cols="12")
            div.pl-2 {{dropdownItem.code}}: {{dropdownItem.name}}
      template(v-slot:cell-input-dropdown-item-variety='{dropdownItem}')
        v-row.px-0.mx-0.dropdown-item
          v-col.px-0.mx-0(cols="12")
            div.pl-2(v-if="dropdownItem.item") [{{dropdownItem.item.code}}: {{dropdownItem.item.name}}] {{dropdownItem.code}}: {{flowerTypePrefix(dropdownItem)}}{{dropdownItem.name}}
            div.pl-2(v-else) {{dropdownItem.code}}: {{flowerTypePrefix(dropdownItem)}}{{dropdownItem.name}}
      template(v-slot:cell-input-dropdown-item-buyer='{dropdownItem}')
        v-row.px-0.mx-0.dropdown-item
          v-col.px-0.mx-0(cols="12")
            div.pl-2(v-if="dropdownItem.branch_code") {{dropdownItem.code}}-{{dropdownItem.branch_code}}: {{dropdownItem.name}}
            div.pl-2(v-else) {{dropdownItem.code}}: {{dropdownItem.name}}
      template(v-slot:cell-input-dropdown-item-color='{dropdownItem}')
        v-row.px-0.mx-0.dropdown-item
          v-col.px-0.mx-0(cols="12")
            div.pl-2 {{dropdownItem.code}}: {{dropdownItem.name}}
      template(v-slot:cell-input-dropdown-item-auction_lane='{dropdownItem}')
        v-row.px-0.mx-0.dropdown-item
          v-col.px-0.mx-0(cols="12")
            div.pl-2 {{dropdownItem.name}}
      template(v-slot:cell-variety='{row, cell}')
        span(:class='{"variety--inactive": row.active == false}') {{cell}}
          v-badge.inactive__badge(
            v-if='row.active == false',
            :content='$t("common.inactive")'
            color='#CACACA'
            offset-x='2'
            offset-y='-2'
          )
      template(v-slot:cell-images='{row}')
        slot(name="cell-images" :row="row" :index="index")
          icon(v-if="row.images > 0" :name="'images'" icon-name="mdi-image-outline" :item-val='row' :color="'primary'" @on-click-icon="onClickIcon")
          icon(v-else-if="row.images === 0" :name="'images'" icon-name="mdi-image-off-outline" :item-val='row' :color="'grey'" @on-click-icon="onClickIcon")
          no-image-icon(v-else)
      template(v-slot:cell-opt='{row}')
        icon(:name="'opt'" icon-name="mdi-pencil" :item-val='row' :color="'darkgrey'" @on-click-icon="onClickIcon")
      template(v-slot:cell-mix_content='{row}')
        icon(:name="'mix_content'" :item-val='row' :color="row.mix_content && row.mix_content.length > 0 ? 'primary' : 'grey'" @on-click-icon="onClickIcon")
      template(v-slot:cell-remark='{row, cell}')
        div.align-left(
          :class="xlRemark ? 'three-dots--max-length' : 'three-dots'"
        ) {{ cell }}
      template(v-slot:cell-count_flower='{row, cell}')
        span {{ cell }}
        span(v-if="cell") {{$t('assignment.count_flower_unit')}}
      template(v-slot:cell-count_stem='{row, cell}')
        span {{ cell }}
        span(v-if="cell") {{$t('assignment.count_stem_unit')}}
      template(v-slot:cell-input-dropdown-no-data-unit='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-size='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-box_type='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-color='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-item='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-quality='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-variety='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-pot_size='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-slot:cell-input-dropdown-no-data-fee='{row, column}')
        span.pl-5.grey--text {{$t('common.no_data')}}
      template(v-for='(_, slot) of $scopedSlots' v-slot:[slot]='scope')
        slot(v-bind='scope', :name='slot')
      template(v-slot:total-box)
        b {{total.box.toLocaleString('en-US')}}
      template(v-slot:total-arrival_box_num)
        b {{total.arrival_box_num.toLocaleString('en-US')}}
      template(v-slot:total-amount)
        slot(name="total-amount")
          b {{total.amount.toLocaleString('en-US')}}
      template(v-slot:cell-published_box_num='{row, cell}')
        slot(name="custom-published_box_num" :row="row" :cell="cell")
      template(v-slot:no-data)
        slot(name="no-data")
          tr(v-if="noDataText")
            td.j-common-form-table__no-data(colspan="99") {{ noDataText }}
      template(v-slot:no-data-custom)
        slot(name="no-data-custom")
  slot(name="pagination")
</template>

<script>
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  toRefs,
  ref,
  onUnmounted,
  computed,
  nextTick
} from 'vue'
// import JSizeDialog from '../JSizeDialog/index.vue'
// import JBoxTypeDialog from '../JBoxTypeDialog/index.vue'
// import JColorDialog from '../JColorDialog/index.vue'
// import JItemDialog from '../JItemDialog/index.vue'
// import JQualityDialog from '../JQualityDialog/index.vue'
// import JUnitDialog from '../JUnitDialog/index.vue'
// import JVarietyDialog from '../JVarietyDialog/index.vue'
// import JPotSizeDialog from '../JPotSizeDialog/index.vue'
// import JArItemDialog from '../JArItemDialog/index.vue'
import { FEditableTable, ProductIcon, AlItemIcon, JHelp } from '@/components'
import {
  addOneRow,
  addRows,
  deleteRows,
  copyRows,
  autoAddEmptyRow,
  flowerTypePrefix
} from '@/utils'
import { ProductType, ARRIVAL_TYPE } from '@/utils/constants'
import Icon from './Images/Icon.vue'
import NoImageIcon from './Images/NoImageIcon.vue'
import { api, i18n } from '@/plugins'
import { endpoints, showError } from '@/utils'
import { DEFAULT_ACTIONS } from './index'
import { cloneDeep } from 'lodash'

const JCommonFormTable = defineComponent({
  components: {
    FEditableTable,
    ProductIcon,
    AlItemIcon,
    JHelp,
    Icon,
    NoImageIcon
    // JBoxTypeDialog,
    // JColorDialog,
    // JItemDialog,
    // JQualityDialog,
    // JSizeDialog,
    // JUnitDialog,
    // JVarietyDialog,
    // JPotSizeDialog,
    // JArItemDialog
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    keyUpdate: {
      type: Number,
      default: 0
    },
    domId: {
      type: String,
      required: false,
      default: null
    },
    sizeGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    unitGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    boxTypeGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    qualityGroups: {
      type: Array,
      required: false,
      default: () => []
    },
    width: {
      default: null
    },
    showShowHideDialog: {
      default: true
    },
    presetColumns: {
      default: () => []
    },
    presetColumn: {
      default: null
    },
    showFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    actions: {
      type: Array,
      required: false,
      default: () => DEFAULT_ACTIONS
    },
    xlRemark: {
      type: Boolean,
      required: false,
      default: false
    },
    isAutoAddEmptyRow: {
      type: Boolean,
      required: false,
      default: true
    },
    isShowContext: {
      type: Boolean,
      required: false,
      default: true
    },
    isAllowSorting: {
      type: Boolean,
      default: true
    },
    isHeaderSortingEnabled: {
      type: Boolean,
      default: true
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    requiredFee: {
      type: Boolean,
      default: true
    },
    isFixedHeader: {
      type: Boolean,
      default: false
    },
    isClipOverFlow: {
      type: Boolean,
      default: false
    },
    isMoveRightOnEnter: {
      type: Boolean,
      default: true
    },
    // 縦入力Enter時、次行のこの列が空なら移動を止める（空欄の列名で無効）
    verticalEnterStopColumn: {
      type: String,
      default: ''
    },
    isFixedHeaderSaleScreen: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoFocusFirstCell: {
      type: Boolean,
      default: false
    },
    keepRowHighlight: {
      type: Boolean,
      default: false
    },
    isFocusSecondCell: {
      type: Boolean,
      default: false
    },
    columnSizes: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultRowData: {
      type: Object,
      defaullt: () => {
        return null
      }
    },
    notCopyProps: {
      type: Array,
      default: () => []
    },
    isShowIndexColumn: {
      type: Boolean,
      default: true
    },
    enablePreDeleteRows: {
      type: Boolean,
      default: false
    },
    resetSort: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { $toast, $refs } = getCurrentInstance().proxy
    const { rows } = toRefs(props)
    const currentRowIndex = ref(null)
    const currentColumn = ref(null)
    const currentSearchInput = ref('')
    const menu = ref(false)
    const isShowSizeDialog = ref(false)
    const isShowBoxTypeDialog = ref(false)
    const isShowColorDialog = ref(false)
    const isShowItemDialog = ref(false)
    const isShowQualityDialog = ref(false)
    const isShowUnitDialog = ref(false)
    const isShowVarietyDialog = ref(false)
    const isShowPotSizeDialog = ref(false)
    const isShowArItemDialog = ref(false)
    const itemValue = ref({})

    const remarkValue = ''

    // const rows = ref(initRow(columns.value))
    const total = computed(() => {
      const output = {
        arrival_box_num: 0,
        stem: 0
      }
      const totalKeys = Object.keys(output)
      rows.value.forEach((row) => {
        totalKeys.forEach((key) => {
          output[key] +=
            !isNaN(Number(parseFloat(row[key]))) ||
            Number(parseFloat(row[key])) === 0
              ? parseFloat(row[key])
              : 0
        })
      })
      return output
    })
    const eventInRightClick = async (event) => {
      /*{
        "event": "handle_add_new_row",
        "actionPayload": {
          "row": {...},
          "rowIndex": 0,
          "column": {...},
          "columnIndex": 4,
          "rows": [
            {...},
            {...}
          ],
          "rowIndexes": [0],
          "columns": [{...}],
          "columnIndexes": [4]
        }
      }*/
      // prevent delete row event even if isShowContext is false
      if (!props.isShowContext) return

      const actionPayload = event.actionPayload
      const numberRowSelect = actionPayload.rows.length
      const firstRowIndex = actionPayload.rowIndexes[0]
      const lastRowIndex = actionPayload.rowIndexes[numberRowSelect - 1]

      if (event.event === 'handle_add_new_row_above') {
        rows.value = addRows(
          rows.value,
          numberRowSelect,
          firstRowIndex,
          true,
          props.defaultRowData
        )
        emit('on-add-new-row-above', rows.value)
      }
      if (event.event === 'handle_add_new_row_below') {
        rows.value = addRows(
          rows.value,
          numberRowSelect,
          lastRowIndex,
          false,
          props.defaultRowData
        )
        emit('on-add-new-row-below', rows.value)
      }
      if (event.event === 'handle_delete_rows') {
        // Do not delete disabled row, just emit event to handle if necessary
        const mapRows = cloneDeep(rows.value).map((r, idx) => {
          return { ...r, idx: idx + 1 }
        })
        const cannotDeleteRows = mapRows
          .slice(firstRowIndex, numberRowSelect + firstRowIndex)
          .filter((delR) => delR?.disabledRow || delR?.disabled)
        const cannotDeleteRowIdxes = cannotDeleteRows.map((r) => r.idx)
        if (cannotDeleteRowIdxes.length > 0) {
          emit('handle-delete-disabled-row', cannotDeleteRowIdxes)
          return
        }
        if (props.enablePreDeleteRows) {
          const result = await new Promise((resolve) => {
            emit('pre-delete-rows', {
              rows: rows.value,
              firstRowIndex,
              lastRowIndex,
              resolve
            })
          })
          if (!result.success) {
            $toast.error(i18n.t('arrival_input.can_not_published_arrival'))
            return
          }
        }

        if (
          mapRows
            .slice(firstRowIndex, numberRowSelect + firstRowIndex)
            .filter((delR) => delR?.isSoldOrPublished).length > 0
        ) {
          $toast.error(i18n.t('arrival_input.can_not_published_arrival'))
          return
        }

        if (
          rows.value
            .slice(firstRowIndex, numberRowSelect + firstRowIndex)
            .filter((delR) => delR?.notEditable).length > 0
        ) {
          $toast.error(i18n.t('common.can_not_delete_row'))
          return
        }

        // Prevent to delete editOnly rows
        if (
          rows.value
            .slice(firstRowIndex, numberRowSelect + firstRowIndex)
            .filter((delR) => delR?.editOnly).length > 0
        ) {
          $toast.error(i18n.t('common.can_not_delete_edit_only_row'))
          return
        }

        const isDeleteAll =
          rows.value.length === numberRowSelect + firstRowIndex
        let isActuallyAddEmptyRow = false
        if (rows.value.length === numberRowSelect + firstRowIndex) {
          isActuallyAddEmptyRow = true
        }
        const [newRows, delRow] = deleteRows(
          rows.value,
          numberRowSelect,
          firstRowIndex
        )
        rows.value = newRows
        emit('on-delete-rows', {
          rows: rows.value,
          delRow,
          firstRowIndex,
          lastRowIndex,
          isDeleteAll
        })
        if (isActuallyAddEmptyRow) {
          emit('on-after-auto-add-empty-row', {
            rows: rows.value,
            emptyRowIndex: rows.value.length - 1
          })
        }
      }
      if (event.event === 'handle_copy_rows') {
        let copyDisabledFields = false
        if (event.actionPayload?.copyDisabledFields)
          copyDisabledFields = event.actionPayload?.copyDisabledFields

        rows.value = copyRows(
          rows.value,
          actionPayload.rows,
          lastRowIndex,
          props.columns,
          props.notCopyProps,
          copyDisabledFields
        )
        emit('on-copy-rows', {
          rows: rows.value,
          firstRowIndex,
          lastRowIndex,
          copyLength: actionPayload.rows.length
        })
      }
      if (event.event === 'handle_open_history') {
        emit('on-open-history', firstRowIndex)
      }
    }

    const onReorder = (newRows) => {
      emit('on-change', newRows.rows)
    }

    const countEntireTotal = () => {
      emit('count-entire-total')
    }

    const onBodyClick = (curCursor) => {
      emit('on-body-click', {
        row: rows.value[curCursor.rowIndex],
        column: props.columns[curCursor.columnIndex],
        rowIdx: curCursor.rowIndex
      })
    }
    const outsideclick = () => {
      emit('on-outside-click')
    }

    const closeDialog = (dialog) => {
      isShowSizeDialog.value = false
      isShowBoxTypeDialog.value = false
      isShowColorDialog.value = false
      isShowItemDialog.value = false
      isShowQualityDialog.value = false
      isShowUnitDialog.value = false
      isShowVarietyDialog.value = false
      isShowPotSizeDialog.value = false
      isShowArItemDialog.value = false
      emit('on-reload', dialog)
    }

    const onInput = (dataInput) => {
      if (dataInput.row) {
        // update new data into row exists
        const index = rows.value.indexOf(dataInput.row)
        rows.value[index][dataInput.column.name] = dataInput.value
        // Auto calculate stem, amount if inputting in box or quantity
        if (
          dataInput.column.name === 'box' ||
          dataInput.column.name === 'quantity'
        ) {
          const box = rows.value[index].box
          const quantity = rows.value[index].quantity
          if (box && quantity) rows.value[index].stem = box * quantity

          const stem = rows.value[index].stem
          const price = rows.value[index].price

          if (stem && price) rows.value[index].amount = price * stem
        }
        // Auto calculate amount if inputting in price or quantity
        if (
          dataInput.column.name === 'price' ||
          dataInput.column.name === 'stem'
        ) {
          const price = rows.value[index].price
          const stem = rows.value[index].stem

          if (stem && price) rows.value[index].amount = price * stem
        }
        if (
          props.isAutoAddEmptyRow &&
          dataInput.key !== 'Delete' &&
          dataInput.key !== 'Backspace'
        ) {
          let isActuallyAddEmptyRow = false
          if (rows.value.length - 1 === index) {
            isActuallyAddEmptyRow = true
          }
          autoAddEmptyRow(rows.value, index)
          if (isActuallyAddEmptyRow) {
            emit('on-after-auto-add-empty-row', {
              rows: rows.value,
              emptyRowIndex: index + 1
            })
          }
        }
      } else {
        // if row not exists => create new row with data is dataInput.value
        const dataRow = {}
        dataRow[dataInput.column.name] = dataInput.value
        rows.value = JSON.parse(
          JSON.stringify(addOneRow(rows.value, null, dataRow))
        )
      }
      emit('on-input', { rows: rows.value, dataInput: dataInput })
    }

    const index = 0
    const onEnterCell = (event) => {
      emit('on-enter-cell', {
        rowIdx: event.cursor.rowIndex,
        colIdx: event.cursor.columnIndex,
        row: rows.value[event.cursor.rowIndex],
        column: event.column
      })
    }
    const onClickIcon = (event) => {
      event.rowIndex = currentRowIndex.value
      emit('on-click-icon', event)
    }
    const updateCursor = (event) => {
      currentRowIndex.value = event.rowIndex
      emit('cursor', event)
    }
    const onBlurCell = (data) => {
      emit('on-blur-cell', {
        rowIdx: data.rowIndex,
        colIdx: data.columnIndex
      })
    }
    const isFixedHeader = ref(props.isFixedHeader)
    const isClipOverFlow = ref(props.isClipOverFlow)
    const changeColumnSizes = (value) => {
      emit('change-columnsizes', value)
    }
    const focusOnCell = (cursor) => {
      const tblDomId = `table-container-${props.domId}`
      const rowIdx = cursor.rowIndex
      const columnIdx = cursor.columnIndex
      // if the currently focused cell is already the requested one, don't refocus
      const currCursor = $refs.commonFrmTbl?.cursor
      if (
        currCursor?.rowIndex === rowIdx &&
        currCursor?.columnIndex === columnIdx
      ) {
        return
      }
      if (
        $refs.commonFrmTbl?.cursor.rowIndex !== null &&
        $refs.commonFrmTbl?.cursor.rowIndex !== undefined
      ) {
        $refs.commonFrmTbl.cursor.columnIndex = columnIdx
        $refs.commonFrmTbl.cursor.rowIndex = rowIdx
      }

      const cell = document
        .getElementById(tblDomId)
        ?.querySelector(
          `td[data-column-index="${columnIdx}"][data-row-index="${rowIdx}"]`
        )
      cell?.click()
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
      $refs.commonFrmTbl.$emit('cellclick', {
        rowIndex: rowIdx,
        columnIndex: columnIdx,
        $event: clickEvent
      })
    }

    const focusOnFirstCell = (rowIndex, colIndex) => {
      $refs.commonFrmTbl?.focusOnFirstCell(rowIndex, colIndex)
    }

    // カーソル枠(青い矩形)が現在どこかのセルを指しているか。セルは編集中
    // (cursor.editing)でない限り本物のinput要素がDOMに存在しないため、
    // 「このテーブル内に実フォーカスがあるか」はdocument.activeElementでは
    // 判定できない。カーソル位置の有無で代わりに判定する
    const hasCursor = () => {
      const cursor = $refs.commonFrmTbl?.cursor
      return !!cursor && cursor.rowIndex >= 0
    }

    // 画面側の都合でテーブル外へフォーカスを移した際、カーソル枠(青い矩形)を
    // 非表示にしたい場合に呼ぶ。実際のDOMフォーカスはこのメソッドでは変更しない。
    // 消す直前の位置を返すので、呼び出し側が後で focusOnCell() に渡して戻せる
    const clearCursor = () => {
      const cursor = $refs.commonFrmTbl?.cursor
      if (!cursor || cursor.rowIndex < 0) return null
      const position = { rowIndex: cursor.rowIndex, columnIndex: cursor.columnIndex }
      cursor.rowIndex = -1
      return position
    }

    onMounted(() => {
      // wrapper-table-container and its scroll-sync removed
      // keep a reference to table container if needed for future features
      const tableContainer = document.getElementById(
        'table-container-' + props.domId
      )
      if (!tableContainer) return
    })

    const disabledInputOrder = (row) => {
      return (
        !row.arrival_type ||
        !row.arrival_box_num ||
        (row.arrival_type &&
          row.arrival_type.includes(ARRIVAL_TYPE.CONSIGNMENT))
      )
    }

    const restoreFocus = () => {
      const cursor = $refs.commonFrmTbl?.cursor
      if (!cursor || cursor.rowIndex < 0) return
      nextTick(() => $refs.commonFrmTbl?.$emit('bodyclick', cursor))
    }

    const onLoadMore = (event) => {
      emit('on-load-more', event)
    }

    return {
      onInput,
      index,
      eventInRightClick,
      menu,
      onReorder,
      isShowItemDialog,
      isShowSizeDialog,
      isShowBoxTypeDialog,
      isShowColorDialog,
      isShowQualityDialog,
      isShowUnitDialog,
      isShowVarietyDialog,
      isShowPotSizeDialog,
      itemValue,
      currentColumn,
      currentSearchInput,
      onBodyClick,
      remarkValue,
      onEnterCell,
      onBlurCell,
      ProductType,
      total,
      closeDialog,
      isShowArItemDialog,
      changeColumnSizes,
      focusOnCell,
      restoreFocus,
      disabledInputOrder,
      outsideclick,
      onClickIcon,
      updateCursor,
      countEntireTotal,
      onLoadMore,
      focusOnFirstCell,
      hasCursor,
      clearCursor,
      flowerTypePrefix
    }
  }
})

export default JCommonFormTable
</script>

<style scoped lang="sass">
.table-container
  .items-table
    min-width: 1280px

td.j-common-form-table__no-data
  background: white
  color: #00000061
  padding: 8px 0
  text-align: center
</style>
